// src/constants/config.js
// Configuration globale de l'application - NE PAS MODIFIER

export const APP_CONFIG = {
  APP_NAME: 'Fynho',
  APP_VERSION: '1.0.0',

  API_BASE_URL: 'https://fynho.com/api',

  DEFAULT_LAT: 4.0511, // Douala
  DEFAULT_LNG: 9.7679,
  DEFAULT_MAP_ZOOM: 12,

  SUPPORT_WHATSAPP: '+19406015676',
  SUPPORT_EMAIL: 'contact@fynho.com',
};

export default APP_CONFIG;